import CreateEmployee from "./Create Employee/CreateEmployee"
import CreateRoles from "./CreateRole/CreateRoles"
import EditViewEmp from "./EditEmployee/EditViewEmp"
import CreateDepartment from "./Create Department/CreateDepartment"
import EditRoles from "./Edit Roles/EditRoles"
import CreateUser from "./UserCreation/CreateUser"
import ProfileManagement from "./Create Employee/ProfileManagement"


export {ProfileManagement, CreateEmployee, CreateRoles, EditViewEmp, CreateDepartment, EditRoles, CreateUser }